import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/notifications.actions';

export const initialState: actions.NotificationStateInterface = {
  newCards: 0,
  notificationsList: [],
};

const markAllViewed = function (state) {
  return state.notificationsList.map(notification => ({...notification, viewed: true }));
}

export const _NotificationReducer = createReducer(initialState,
  on(actions.reset, (state) => ({...state, notificationsList: [], newCards: 0})),
  on(actions.allViewed, (state) => ({...state, newCards: 0, notificationsList: markAllViewed(state)}) ),
  on(actions.updateCards, (state, {notifications}) => {
    return {
      ...state,
      notificationsList: notifications,
      newCards: notifications.filter(cards => !cards.viewed).length
    }
  })
);



export function NotificationReducer(state, action) : actions.NotificationStateInterface {
  return _NotificationReducer(state, action);
}